<!-- 
difference between RadioButtonToggleHiddenQuestion.vue and RadioBaseToggleHiddenQuestion?
  1. v-radio is replaced with v-btn
  2. added getValue() click event to v-btn
  3. getValue() targets the buttons text and assigns to the question.Value
  4. setQuestionVisibility() method goes inside the getValue() method
  5. the styles used here should ONLY be used for this component
 -->
<template>
  <div :class="[question.StyleClass, question.Source?.toLowerCase()]">
    <HomeBaseLabel :question="question" :class="[question?.LabelStyleClass]" />
    <v-radio-group
      row
      hide-details="auto"
      class="radioButton mt-n4"
      :data-uiid="question.DataUiid"
      v-model="question.Value"
      :rules="getRules"
    >
      <v-btn
        v-for="(option, index) in question.Options"
        :key="index"
        :ripple="false"
        outlined
        min-width="100"
        max-width="100%"
        color="primary"
        class="font-weight-normal font-20 flex-shrink-0 mt-5 mr-4 text-none"
        large
        rounded
        :class="[
          question.Value === convertToStrings(option.Value)
            ? 'radioButton--active font-weight-bold'
            : '',
          question?.ButtonStyleClass,
        ]"
        :data-uiid="option.DataUiid"
        @click="getValue(option, true)"
      >
        <span v-if="option.MobileText">
          <span v-if="$vuetify.breakpoint.lgAndUp">{{ option.Text }}</span>
          <span v-else>{{ option.MobileText }}</span>
        </span>
        <span v-else>{{ option.Text }}</span>
      </v-btn>
    </v-radio-group>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import {
  APPLICATION_MODULE,
  QUESTIONS_MODULE,
} from "@/store/types/module-types";
import { mapActions } from "vuex";

export default {
  name: "RadioButtonToggleHiddenQuestion.vue",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
    labelClass: {
      type: String,
      default: () => "",
    },
  },
  mounted() {
    if (this.question.Value) {
      this.getValue({ Value: this.question.Value });
    }
  },
  methods: {
    // Using Actions from multiple modules
    // requires swapping the mapActions Array to an Object and assigning the Action to a key
    // you then reference the Action by the key
    ...mapActions(QUESTIONS_MODULE, {
      questionsModule: "setQuestionVisibility",
    }),
    ...mapActions(APPLICATION_MODULE, {
      applicationModule: "setQuestionVisibility",
    }),
    getValue(option, resetSource = false) {
      this.question.Value = this.convertToStrings(option.Value);
      this.questionsModule(this.question);
      this.applicationModule(this.question);
      if (resetSource) this.question.Source = "User";
    },
    convertToStrings(value) {
      return value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.your-app-yes-no-button {
  width: 110px !important;
  height: 48px !important;
}
</style>
